// ResourceMenuStore.js

import { writable, get } from 'svelte/store';

export const level0Node = writable(null);
export const level1Node = writable(null);
export const level2Node = writable(null);
export const level3Node = writable(null);
export const level4Node = writable(null);

export const currentMenuLevel = writable(null);
export const currentMenuNode = writable(null);
export const currentMenuButton = writable(null);
